import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import ActionsContext from "common/ActionsContext";
import MetricsHelpModal from "./Help";
import FilteringControls from "./FilteringControls";
import Report from "./Report";
import { Header } from "common/Header";

const FilterLayout = styled.div`
  .form-line {
    input.form-control {
      z-index: 0 !important;
    }
  }
`;

const ContextMenu = () => {
  const actions = useContext(ActionsContext);
  return (
    <ul className="context-menu header-dropdown m-r--5">
      <a
        data-loading-effect="pulse"
        data-toggle="cardloading"
        title="Help"
        onClick={() => actions.send("open-help")}
      >
        <i className="material-icons">help_outline</i>
      </a>
      <a
        onClick={() => actions.send("do-load")}
        data-toggle="cardloading"
        data-loading-effect="pulse"
        title="Refresh"
      >
        <i className="material-icons">refresh</i>
      </a>
    </ul>
  );
};

export const applyParams = (child, params = {}) =>
  React.isValidElement(child) ? React.cloneElement(child, params) : child;

const Subscribers = ({ subnet, returnView, ...params }) => {
  const actions = useContext(ActionsContext);
  useEffect(() => () => actions.clear(), []);
  return (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div className="card">
        <Header
          title="Subscriber Attributes"
          contextMenu={<ContextMenu />}
          backButton={!!returnView}
        />
        <FilterLayout className="body flex-panel-column subscriber-quotas panel-group">
          <FilteringControls  {...params} subnet={subnet}>
            {(settings) => <Report {...settings} />}
          </FilteringControls>
        </FilterLayout>
        <MetricsHelpModal />
      </div>
    </div>
  );
};

export default Subscribers;
